export default __webpack_public_path__ + "static/media/ic_simpleswaps.2005009f.svg";